function cleanPath(path) {
	if (path[0] == '/')
		return path.substring(1);
	else
		return path
}
function getCookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}
function setCookie(name, value, options) {
	options = options || {};

	var expires = options.expires;

	if (typeof expires == "number" && expires) {
		var d = new Date();
		d.setTime(d.getTime() + expires * 1000);
		expires = options.expires = d;
	}
	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	value = encodeURIComponent(value);

	var updatedCookie = name + "=" + value;

	for (var propName in options) {
		updatedCookie += "; " + propName;
		var propValue = options[propName];
		if (propValue !== true) {
			updatedCookie += "=" + propValue;
		}
	}

	document.cookie = updatedCookie;
}
function deleteCookie(name) {
	setCookie(name, "", {
		expires: -1
	})
}
(function(dom, utils, config){

	utils.delayRender = function(callback){
		return setTimeout(callback, config.renderDelay);
	};

	utils.delayDuration = function(callback){
		return setTimeout(callback, config.duration);
	};

	utils.prevent = function(e){
		e.preventDefault();
	};

	utils.loadedAPI = false;
	utils.loadYandexMapAPI = function (init, params) {
		if (!utils.loadedAPI) {
			setTimeout(function () {
				var script = document.createElement('script');

				script.src = '//api-maps.yandex.ru/2.1/?lang=ru-RU';
				document.body.appendChild(script);

				script.onload = function() {
					utils.loadedAPI = true;3
					ymaps.ready(function () {
						init(params);
					});
				};
			}, 800);
		} else {
			setTimeout(function () {
				init(params);
			}, 800);
		}
	};
	$.inViewport = function(element){
		var viewport = {},
			bounds = $(element).offset(),
			win_height = app.dom.$window.height();

		viewport.top = app.dom.$window.scrollTop() + (win_height / 5);
		viewport.bottom = app.dom.$window.scrollTop() + win_height - (win_height / 5);
		bounds.bottom = bounds.top + $(element).outerHeight();
		return (!(viewport.bottom <= bounds.top || viewport.top > bounds.bottom));
	};
	$.extend($.expr[':'], {
		'in-viewport': function(element) {
			return $.inViewport(element);
		}
	});
	utils.pageScroll = {};
	utils.pageScroll.disable = function(){
		dom.$document.on('touchmove', function(event){
			event.preventDefault();
		});
		dom.$window.on('mousewheel', function(event){
			event.preventDefault();
		});
	};
	utils.pageScroll.enable = function(){
		dom.$document.off('touchmove');
		dom.$window.off('mousewheel');
	};
})(app.dom, app.utils, app.config);